import { createSlice } from '@reduxjs/toolkit';
import {
  MergedPackageModel,
  MyOrderListModel,
  Subscription,
  UserPackageModel
} from '../views/Marketplace/Maeketplace.types';
import {
  addHub,
  getBigWhale,
  getTravelPackages,
  getMarketplace,
  getTradingHubs,
  purchasePackage,
  getFlipmeCards,
  getAkashaHubs,
  getTravelutionSubscriptions,
  getDepositAkashaInfo,
  getAkashaWalletSummary,
  depositAkasha,
  getGuardianNodes,
  getEntryPackages,
  getKriptoTapPackages
} from '../views/Marketplace/Marketplace.actions';

export interface MarketplaceSliceType {
  loading: boolean;
  addHubLoading: boolean;
  currencyType: number;
  hubs: MergedPackageModel[];
  subscriptions: MergedPackageModel[];
  userPackage: UserPackageModel | null;
  subscription: Subscription | null;
  walletSummary: any;
  exchangeRates: any;
}

const initialState = {
  loading: false,
  addHubLoading: false,
  currencyType: 0,
  hubs: [],
  subscriptions: [],
  userPackage: null,
  subscription: null,
  walletSummary: null,
  exchangeRates: null
} as MarketplaceSliceType;

const marketplaceSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getMarketplace.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(getMarketplace.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getMarketplace.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    builder.addCase(getTradingHubs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTradingHubs.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getTradingHubs.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getTravelutionSubscriptions.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(
      getTravelutionSubscriptions.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.subscriptions = payload.hubs;
        //state.userPackages = payload.userPackages;
      }
    );
    builder.addCase(getTravelutionSubscriptions.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    // BIG WHALE
    builder.addCase(getBigWhale.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBigWhale.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getBigWhale.rejected, (state) => {
      state.loading = false;
    });

    // TRAVEL PACKAGES
    builder.addCase(getTravelPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTravelPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getTravelPackages.rejected, (state) => {
      state.loading = false;
    });

    // FLIPME CARDS
    builder.addCase(getFlipmeCards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFlipmeCards.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getFlipmeCards.rejected, (state) => {
      state.loading = false;
    });

    // AKASHA HUBS
    builder.addCase(getAkashaHubs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAkashaHubs.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getAkashaHubs.rejected, (state) => {
      state.loading = false;
    });

    // GUARDIAN NODES
    builder.addCase(getGuardianNodes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getGuardianNodes.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getGuardianNodes.rejected, (state) => {
      state.loading = false;
    });

    // DEXNET NODES
    builder.addCase(getEntryPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEntryPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getEntryPackages.rejected, (state) => {
      state.loading = false;
    });

    // KRIPTOTAP
    builder.addCase(getKriptoTapPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getKriptoTapPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getKriptoTapPackages.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addHub.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(addHub.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      if (payload) {
        state.userPackage = payload.userPackage;
        state.currencyType = payload.currencyType;
      }
    });

    builder.addCase(purchasePackage.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchasePackage.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      if (payload) {
        state.userPackage = payload.userPackage;
      }
      if (payload?.subscription) {
        state.subscription = payload.subscription;
      }
    });

    builder.addCase(addHub.rejected, (state) => {
      state.addHubLoading = false;
    });

    //akasha deposit

    builder.addCase(depositAkasha.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(depositAkasha.fulfilled, (state, { payload }) => {
      state.loading = false;
    });

    builder.addCase(depositAkasha.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getDepositAkashaInfo.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getDepositAkashaInfo.fulfilled, (state, { payload }) => {
      state.loading = false;
      if (payload) {
        state.userPackage = payload.userPackage;
      }
    });

    builder.addCase(getDepositAkashaInfo.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getAkashaWalletSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAkashaWalletSummary.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.walletSummary = payload?.walletSummary;
      state.exchangeRates = payload?.exchangeRates;
    });

    builder.addCase(getAkashaWalletSummary.rejected, (state) => {
      state.loading = false;
    });
  }
});

// export const { clearHubs } = marketplaceSlice.actions;

export default marketplaceSlice.reducer;
